export default "__VITE_ASSET__DQ0sooPa__"